import React from "react";
import { Flame } from "lucide-react";
import { HERO_IMAGE } from "../data/menu";

export default function FacebookCover() {
  return (
    <div className="min-h-screen bg-zinc-800 flex items-center justify-center p-6">
      <div className="flex flex-col items-center gap-6">
        <p className="font-['Outfit'] text-zinc-300 text-sm uppercase tracking-[0.3em]">
          Facebook Cover · 1640×720 (FB safe-zone center)
        </p>

        <div
          data-testid="fb-cover"
          className="relative w-[820px] h-[360px] overflow-hidden bg-black"
        >
          {/* Background image with overlays */}
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `url(${HERO_IMAGE})`,
              backgroundSize: "cover",
              backgroundPosition: "center 40%",
              filter: "saturate(1.1) contrast(1.05)",
            }}
          />
          {/* Left-side gradient for legible text */}
          <div className="absolute inset-0 bg-gradient-to-r from-black via-black/70 to-transparent" />
          {/* Bottom vignette */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-black/30" />
          {/* Subtle grain */}
          <div
            aria-hidden="true"
            className="absolute inset-0 opacity-30 mix-blend-screen pointer-events-none"
            style={{
              backgroundImage:
                "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/><feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")",
            }}
          />

          {/* Content — centered for mobile crop safety */}
          <div className="relative z-10 h-full flex items-center px-12">
            <div className="max-w-[520px]">
              <div className="flex items-center gap-3 mb-3">
                <Flame
                  className="text-[#FF3B30] drop-shadow-[0_0_15px_rgba(255,59,48,0.7)]"
                  style={{ width: 22, height: 22 }}
                />
                <span
                  className="font-['Outfit'] uppercase text-[#FF8C00]"
                  style={{ fontSize: 11, letterSpacing: "0.45em" }}
                >
                  Low · Slow · Smokey AF
                </span>
              </div>

              <h1
                className="font-['Anton'] uppercase text-white leading-[0.85]"
                style={{ fontSize: 76, letterSpacing: "-0.02em" }}
              >
                Smokey{" "}
                <span className="text-[#FF3B30] drop-shadow-[0_0_18px_rgba(255,59,48,0.5)]">
                  AF
                </span>
                <br />
                Barbecue
              </h1>

              <p
                className="mt-4 font-['Outfit'] italic text-zinc-200"
                style={{ fontSize: 16 }}
              >
                Hand-pulled. Wood-fired. Honest as hell.
              </p>

              <div className="mt-5 flex items-center gap-4">
                <span
                  className="font-['Anton'] tracking-widest uppercase bg-[#FF3B30] text-white px-4 py-2"
                  style={{ fontSize: 13 }}
                >
                  Order Online
                </span>
                <span
                  className="font-['Outfit'] uppercase tracking-[0.4em] text-zinc-400"
                  style={{ fontSize: 11 }}
                >
                  smokey-af-bbq.emergent.host
                </span>
              </div>
            </div>
          </div>

          {/* Right-side small accent — only visible on desktop crop */}
          <div className="absolute right-8 top-1/2 -translate-y-1/2 z-10 hidden md:flex flex-col items-end gap-2 opacity-80">
            <span
              className="font-['Outfit'] uppercase tracking-[0.45em] text-zinc-400"
              style={{ fontSize: 10 }}
            >
              Est. 2026
            </span>
            <span
              className="font-['Outfit'] uppercase tracking-[0.45em] text-[#FF8C00]"
              style={{ fontSize: 10 }}
            >
              Fremont · NE
            </span>
          </div>
        </div>

        <a
          href="/smokey-af-fb-cover.png"
          download
          data-testid="cover-download-link"
          className="font-['Anton'] text-sm tracking-widest uppercase bg-[#FF3B30] hover:bg-white hover:text-black text-white px-6 py-3 transition-colors"
        >
          Download PNG
        </a>
      </div>
    </div>
  );
}
